/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import { FSMFactoryModule } from "@vlinder-web/state-machine-factory-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { BaseApplication } from "./base/baseApplication";
import { UnitTest } from "./unit.test";
import {
    TrafficLightService,
    DeviceInfoService,
    DummyRestService,
    DummyGraphQLService,
    EditProductInfoService,
    FeedBackFormService,
    ProductViewService,
    ProductDetailViewService,
    ProvenanceStepDetailViewService,
    ProductProvenanceService,
    ProductViewRestService,
    FeedbackRestService,
    ProductDetailRestService,
    ProductProvenanceRestService,
    ProductProvenanceStepRestService,
} from '../services';

import { StorageModule } from "@vlinder-web/storage-module-react";

export class VApplication extends BaseApplication {
    private static instance: VApplication;

    private constructor(options: any = {}) {
        super(options);

        this.setupBindings();

        //Modules
        this.initModules();

        //Services
        this.initServices();
    }

    static getInstance(options: any = {}) {
        if (!this.instance) {
            this.instance = new VApplication(options);
        }
        return this.instance;
    }

    // @ts-ignore
    async start() {
        await this.initRunLevel();
        await this.unitTest();
    }

    setupBindings() {
        //------------->>>>>--------------//
        // this.configure('services.DummyRestService', {
        //     baseURL: DEFAULT_APP_CONFIG?.servers.rest.dummyRestServer.baseURL,
        // });
        //------------->>>>>--------------//
        const storageService = StorageModule.getInstance();
        const DEFAULT_APP_CONFIG = storageService.get("appConfig", "session");
        console.log(`DEFAULT_APP_CONFIG`,DEFAULT_APP_CONFIG)

        this.configure("services.ProductViewRestService", {
            baseURL: DEFAULT_APP_CONFIG?.servers.rest?.restServer.baseURL,
            // baseURL: "https://kiran-2.vlinderserver.online/trag"
        });
        this.configure("services.ProductDetailRestService", {
            baseURL: DEFAULT_APP_CONFIG?.servers.rest?.restServer.baseURL,
            // baseURL: "https://kiran-2.vlinderserver.online/trag"
        });
        this.configure("services.ProductProvenanceRestService", {
            baseURL: DEFAULT_APP_CONFIG?.servers.rest?.restServer.baseURL,
            // baseURL: "https://kiran-2.vlinderserver.online/trag"
        });
        this.configure("services.ProductProvenanceStepRestService", {
            baseURL: DEFAULT_APP_CONFIG?.servers.rest?.restServer.baseURL,
            // baseURL: "https://kiran-2.vlinderserver.online/trag"
        });
        this.configure("services.FeedbackRestService", {
            baseURL: DEFAULT_APP_CONFIG?.servers.rest?.restServer.baseURL,
            // baseURL: "https://kiran-2.vlinderserver.online/trag"
        });
    }

    async initRunLevel() {
        //------------->>>>>--------------//
        // const graphqlModule = this.getSync(
        //     'services.GraphqlServerModule',
        // ) as GraphqlServerModule;
        // if (graphqlModule) {
        //     type TClient = typeof DEFAULT_APP_CONFIG.servers.graphql[0];
        //     DEFAULT_APP_CONFIG.servers.graphql.forEach(
        //         async (client: TClient) => {
        //             await graphqlModule.createClient(client.name, {
        //                 url: client.url,
        //                 getContext: this.getGraphQLContext.bind(this),
        //             });
        //         },
        //     );
        // }
        //------------->>>>>--------------//
    }

    async unitTest() {
        const ut = new UnitTest(VApplication);
        ut.run();
    }

    initModules() {
        this.service("services.FSMFactoryModule", FSMFactoryModule);
        this.service("services.EventBusModule", EventBusModule);
        this.service('services.GraphqlServerModule', GraphqlServerModule);
    }

    initServices() {
        this.service('services.TrafficLightService', TrafficLightService);
        this.service('services.DummyRestService', DummyRestService);
        this.service('services.DeviceInfoService', DeviceInfoService);
        this.service('services.DummyGraphQLService', DummyGraphQLService);
        this.service('services.EditProductInfoService', EditProductInfoService);
        this.service('services.FeedBackFormService', FeedBackFormService);
        this.service('services.FeedbackRestService', FeedbackRestService);
        this.service('services.ProductViewService', ProductViewService);
        this.service('services.ProductViewRestService', ProductViewRestService);
        this.service('services.ProductDetailViewService', ProductDetailViewService);
        this.service('services.ProductDetailRestService', ProductDetailRestService);
        this.service('services.ProvenanceStepDetailViewService', ProvenanceStepDetailViewService);
        this.service('services.ProductProvenanceStepRestService', ProductProvenanceStepRestService);
        this.service('services.ProductProvenanceService', ProductProvenanceService);
        this.service('services.ProductProvenanceRestService', ProductProvenanceRestService);
    }

    // private getGraphQLContext() {
    //     const deviceInfoService = this.getSync(
    //         'services.DeviceInfoService',
    //     ) as DeviceInfoService;
    //     console.log('graphqlContext call');
    //     //FIXME:
    //     return {
    //         headers: {
    //             authentication: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYxNTZlOTFlMDM2ODc2NDZmOTUzYWJhNCIsImVtYWlsIjoiaW5mb0B2bGluZGVyLmlvIiwiZmVhdHVyZXMiOlsiQ09OU1VNRVIiXSwiaWF0IjoxNjMzMDg3NjgzfQ.K2FS_nnqIHM0EsfXQ9jrII2EJiJu3YH5PJy21RkBbns',
    //             headers: {
    //                 ...{ ...deviceInfoService?.getDeviceInfo() },
    //                 ...{ ...deviceInfoService?.getAppInfo() },
    //             },
    //         },
    //     };
    // }

}
